import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  featuredListings: [],
  bookmarkedListings: [],
  productListings: [],
};

const DashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setFeaturedListings: (state, action) => {
      state.featuredListings = action.payload;
    },
    setBookmarkedListings: (state, action) => {
      state.bookmarkedListings = action.payload;
    },
    setProductListings: (state, action) => {
      state.productListings = action.payload;
    },
    resetDashboardSlice: () => initialState,
  },
});

export const { setFeaturedListings, setBookmarkedListings, setProductListings, resetDashboardSlice } =
  DashboardSlice.actions;

export default DashboardSlice.reducer;
